
import { FAQ_QUESTION_LIST } from '@/const/api/faq';
import AppDataWaiting from '~/components/common/AppDataWaiting';

export default {
    name: 'FAQSection',
    components: {
        AppDataWaiting,
        VPagination: () => import('@/components/ui/VPagination')
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            items: null,
            meta: {
                page: 1,
                limit: 10,
                total: 0
            }
        }
    },
    watch: {
        'section.id': {
            handler(value) {
                this.getItems();
            },
            immediate: true
        }
    },
    methods: {
        handleChangePagination(page) {
            this.getItems(page);
        },
        getItems(page = 1, limit = this.meta.limit) {
            this.items = null;
            return this.$axios(FAQ_QUESTION_LIST, {
                params: {
                    page,
                    limit,
                    'filter[section_id][eq]': this.section.id
                }
            })
                .then(({ data }) => {
                    this.items = data?.items;
                    this.meta = data?.meta;
                });
        }
    }
}
